webpackJsonp([275],{

/***/ 1080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.5.5 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1895:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1080),
  /* template */
  __webpack_require__(2432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.5.5-116.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.5.5-116.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-be0b0aca", Component.options)
  } else {
    hotAPI.reload("data-v-be0b0aca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2432:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.5.5 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add raw menu item for on-click-menu event #1772")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support hideOnBlur #1742")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell-box.html"
    }
  }, [_vm._v("CellBox")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] Remove default slot's div wrapper #1769")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add method:setInputValue #1746")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/countup.html"
    }
  }, [_vm._v("Countup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:tag for customize tag #1739")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:compute-hours-function #1749")]), _vm._v(" "), _c('li', [_vm._v("[enhance] better mask transition")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support multi select #1446 #1467")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Auto hide popup on deactived #1774")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] swipeout-item add render method #1688")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/tabbar.html"
    }
  }, [_vm._v("Tabbar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support replace: true for link #1761")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add $event param for on-focus on-blur event #1770")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix empty value checking logic #1759")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be0b0aca", module.exports)
  }
}

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1895);

/***/ })

});


// WEBPACK FOOTER //
// 275.d40fd95d.js